import { Component, OnInit } from '@angular/core';
import { ChallengesService } from 'src/app/gamification/command-center/services/challenges.service';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';

@Component({
  selector: 'cv-admin-challenge',
  templateUrl: './cv-admin-challenge.component.html',
  styleUrls: ['./cv-admin-challenge.component.scss']
})
export class CvAdminChallengeComponent implements OnInit  {
    isCxone: boolean = true;
    
    ngOnInit(): void {
        this.isCxone = true;
    }
}
